"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    if (!theme) {
        theme = styling_1.getTheme();
    }
    var DefaultStyles = {
        root: {
        /*
        display: "flex",
        flexDirection: "column"
        */
        },
        appDetails: {
        /*
        margin: "auto",
        alignSelf: "center",
        width: "90%",
        maxWidth: 1300
        */
        },
        content: {
            display: "flex"
        },
        metadata: {
            width: 240,
            padding: 8
        },
        metadataSection: {
            marginTop: 8
        },
        metadataSectionTitle: {
            margin: 0,
            paddingBottom: 4,
            fontSize: styling_1.FontSizes.small,
            fontWeight: styling_1.FontWeights.semibold
        },
        metadataSectionContent: {
            fontWeight: styling_1.FontWeights.light,
            fontSize: styling_1.FontSizes.small
        },
        detailContent: {
            paddingTop: 8,
            maxWidth: "calc(100% - 240)"
        },
        detailTabs: {},
        summary: {
            selectors: {
                ".ms-RatingStar-front": {
                    color: theme.palette.yellow
                }
            }
        },
        title: {
            paddingLeft: 8,
            fontSize: styling_1.FontSizes.xLarge,
            fontWeight: styling_1.FontWeights.semibold
        },
        shortDescription: {
            padding: 8,
            fontSize: styling_1.FontSizes.mediumPlus,
            fontWeight: styling_1.FontWeights.semibold
        },
        actions: {
            display: "flex",
            alignItems: "center",
            marginTop: 8,
            selectors: {
                ".ms-Button+.ms-Button": {
                    marginLeft: 8
                }
            }
        },
        description: {
            padding: 8,
            whiteSpace: "pre-wrap"
        },
        banner: {
            width: 220,
            height: 137,
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            selectors: {
                "&.is-icon": {
                    backgroundColor: theme.palette.neutralLight,
                    color: theme.palette.orange
                },
                ".banner-icon": {
                    fontSize: styling_1.FontSizes.xxLarge
                }
            }
        },
        rating: {
            marginTop: 8,
            display: "flex",
            selectors: {
                ".ms-RatingStar-front": {
                    color: theme.palette.yellow
                }
            }
        },
        reviewCount: {
            paddingLeft: 8
        }
    };
    return styling_1.concatStyleSets(DefaultStyles, customStyles);
});
exports.getStyles = getStyles;
